import { hasValue } from '@r-and-a-shared-ui/utils';
import { useFormContext } from 'react-hook-form';
import styles from './FormTextPreview.module.scss';
import { FormFieldPreviewProps } from '../FormFieldPreview/FormFieldPreview';

export const FormTextPreview = (props: FormFieldPreviewProps) => {
  const { name, label, hideLabel } = props;
  const {
    formState: { errors },
    watch,
  } = useFormContext();

  const value = watch(name);

  return (
    <div className={styles.cell}>
      {!hideLabel && hasValue(label) && (
        <label className={styles.label}>{label}</label>
      )}
      {hasValue(value) && <div className={styles.value}>{value}</div>}
    </div>
  );
};

export default FormTextPreview;
